module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /home/svc.teamcity.prd/BuildAgent/work/80562bb639a6ae70/node_modules/core-js/modules/_fails.js
// module id = umMR
// module chunks = 8